var _excluded = ["whenIdle", "whenVisible", "didHydrate", "className", "style", "noWrapper"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// Lazy Hydration abstraction
import React from 'react';
import lh from 'react-lazy-hydration';
var LazyHydrate = _ref => {
  var {
      whenIdle,
      whenVisible,
      didHydrate,
      className,
      style,
      noWrapper
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (noWrapper) return /*#__PURE__*/React.createElement(React.Fragment, null, rest.children);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, Object.assign(rest, style ? {
    style
  } : {})));
};
LazyHydrate.propTypes = lh.propTypes;
LazyHydrate.defaultProps = lh.defaultProps;
export default process.env.NODE_ENV === 'test' ? LazyHydrate : lh;